module.exports = __webpack_public_path__ + "img/H_emprende.5d7ec323.png";